import React from 'react';
import classes from './CustomLegend.module.css';
const CustomLegend = ({ color, name, value, numbers }) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.indicator}>
        <span className={classes.circle} style={{ background: color }} />
        <p className={classes.name}>{name}</p>
      </div>
      <p className={classes.number}>
        {value} ({numbers == 0.01 ? '0.00' : numbers} Patients)
      </p>
    </div>
  );
};

export default CustomLegend;
